import React from 'react';
import { Button } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useFacebookOAuth } from './hooks/useFacebookOAuth';

export default function FacebookLogin({
    onSuccess,
    onError,
    onNonOAuthError,
}) {
    const { appId, scriptLoadedSuccessfully } = useFacebookOAuth();

    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;

    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    const onNonOAuthErrorRef = useRef(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;

    useEffect(() => {
        if (!scriptLoadedSuccessfully) return;

        window.fbAsyncInit = function() {
            /*global FB*/
            FB.init({
                appId,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v16.0',
            });

            FB.getLoginStatus(function(credentialResponse) {   // Called after the JS SDK has been initialized.
                console.log('statusChangeCallback');
                if (credentialResponse.status === 'connected') {   // Logged into your webpage and Facebook.
                    FB.api('/me?fields=id,name,email', function(profileResponse) {
                        onSuccessRef.current({ credentialResponse, profileResponse });
                    });
                } else {                                 // Not logged into your webpage or we are unable to tell.
                    console.log('Please log into this webpage.');
                }
            });

            FB.login(function(credentialResponse) {
                if (credentialResponse.authResponse) {
                    FB.api('/me?fields=id,name,email', function(profileResponse) {
                        onSuccessRef.current({ credentialResponse, profileResponse });
                    });
                } else {
                    console.log('User cancelled login or did not fully authorize.');
                }
            }, { scope: 'public_profile,email' })
        }
    }, []);



    return (
        <Button
            onClick={() => {

            }}
        >Continue with Facebook1
            
        </Button>
    );
}
